export default __webpack_public_path__ + "static/media/O-111.06013742.png";